import React, {memo} from "../../../__snowpack__/pkg/react.js";
import {Cascader} from "../../../__snowpack__/pkg/antd.js";
export const BaseCascader = memo((props) => {
  const {expandTrigger, ...otherProps} = props;
  return /* @__PURE__ */ React.createElement(Cascader, {
    expandTrigger: "click",
    ...otherProps
  });
});
